import React from 'react';

import config from 'configs/app';
import { BECH_32_SEPARATOR } from 'lib/address/bech32';
import { useI18n } from 'lib/contexts/i18n';
import { useSettingsContext } from 'lib/contexts/settings';
import { Switch } from 'toolkit/chakra/switch';

const SettingsAddressFormat = () => {
  const settingsContext = useSettingsContext();
  const { t } = useI18n();

  if (!settingsContext || config.UI.views.address.hashFormat.availableFormats.length < 2) {
    return null;
  }

  const { addressFormat, toggleAddressFormat } = settingsContext;

  return (
    <Switch
      id="address-format"
      defaultChecked={ addressFormat === 'bech32' }
      onChange={ toggleAddressFormat } mt={ 4 }
      size="md"
      flexDirection="row-reverse"
      justifyContent="space-between"
      w="100%"
      gap={ 2 }
      fontWeight="400"
      color="text.secondary"
    >
      { t('settings.show_address_format', { prefix: `${ config.UI.views.address.hashFormat.bech32Prefix }${ BECH_32_SEPARATOR }` }) }
    </Switch>
  );
};

export default React.memo(SettingsAddressFormat);
